/* eslint-disable */
import React, { ReactNode } from 'react';
import { useStore } from '@thd-nucleus/experience-context'
import { Metadata } from '@thd-olt-component-react/metadata';
import { QueryProvider } from '@thd-nucleus/data-sources';

type MergeProps = {
  query: string;
  mounted: boolean;
}

type ContainerProps = {
  children: ReactNode
}

export const DefaultPageContainer = ({ children }: ContainerProps) => {
  const store = useStore();
  const { storeId, storeZip: zipCode } = store;

  const defaultVariables = {
    storeId,
    zipCode
  };

  return (
    <Metadata>
      <QueryProvider cacheKey="page" defaultVariables={defaultVariables} fusion>
        {children}
      </QueryProvider>
    </Metadata>
  );
};

DefaultPageContainer.propTypes = {
};

DefaultPageContainer.displayName = 'DefaultPageContainer';

DefaultPageContainer.defaultProps = {};
